// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ##### -> Components -> Code for Detailed, GenOverView*/

.css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {
  font-weight: bolder;
}

.left_box_1 {
  font-size: 1.3vmax;
}

.detail_overview_container {
  background: linear-gradient(to right, whitesmoke, white);
  background: linear-gradient(to right, rgb(120, 118, 118), rgb(119, 100, 100));
  background: linear-gradient(
    to bottom,
    rgb(3, 99, 125),
    rgb(4, 128, 162),
    rgb(4, 135, 172)
  );
  
}

.detail_overview_container > :first-child {
  display: flex;
  align-items: center;
  height: 100%;
  background-color: white;
  justify-content: space-between;
  gap: 2vmax;
  padding:1vmax 0.5vmax;
  position: relative;
}

.detail_overview_container > :nth-child(2) {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: white;
  gap: 2vmax;
  padding:1vmax 0.5vmax;
  position: relative;
}

.detail_overview_container > :nth-child(3) {
  display: flex;
  align-items: center;
  height: 100%;
  background-color: white;
  justify-content: space-between;
  gap: 2vmax;
  padding:1vmax 0.5vmax;
  position: relative;
}

/* ###   Code For Detailed Container 1 --> Box-1    ### */

.detail_overview_1 > :first-child {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1vmax;

}

.detail_overview_1 > :first-child > div {
  display: flex;
  flex-direction: column;
  gap: 1.5vmin;


}

.detail_overview_1 > :first-child > div > :first-child > progress {
  appearance: none;
  height: 1rem;
  width: 100%;
  transition: border 0.2s linear;
  transition: 0.2s all;
}

.progress_1[value]::-webkit-progress-bar,
.progress_2[value]::-webkit-progress-bar,
.progress_3[value]::-webkit-progress-bar,
.progress_4[value]::-webkit-progress-bar,
.progress_5[value]::-webkit-progress-bar {
  background-color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
  border-radius: 18px;
}

.progress_1[value]::-webkit-progress-value,
.progress_2[value]::-webkit-progress-value,
.progress_3[value]::-webkit-progress-value,
.progress_4[value]::-webkit-progress-value,
.progress_5[value]::-webkit-progress-value {
  border-radius: 18px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background: linear-gradient(to right, red, rgb(238, 201, 201));
}

.progress_1[value]::-webkit-progress-value {
  background: linear-gradient(
    to right,
    rgb(1, 185, 127),
    rgb(150, 249, 227)
  ) !important;
}

.progress_2[value]::-webkit-progress-value {
  background: linear-gradient(
    to right,
    rgb(231, 3, 3),
    rgb(250, 96, 96)
  ) !important;
}

.progress_3[value]::-webkit-progress-value {
  background: linear-gradient(
    to right,
    rgb(84, 4, 197),
    rgb(151, 140, 239)
  ) !important;
}

.progress_4[value]::-webkit-progress-value {
  background: linear-gradient(
    to right,
    rgb(1, 185, 127),
    rgb(150, 249, 227)
  ) !important;
}

.progress_5[value]::-webkit-progress-value {
  background: linear-gradient(
    to right,
    rgb(231, 3, 3),
    rgb(250, 96, 96)
  ) !important;
}

.detail_overview_1 > :last-child {
}

.detail_overview_1 > :first-child > div > :last-child {
  position: relative;
  width: 100%;
  font-size: 0.8vmax;
  padding: 0 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;


}

.detail_overview_1 > :first-child > div > :last-child > span > i {
  font-size: 1.4vmax;
  color: rgb(98, 92, 92);
}

.detail_overview_container > :first-child > :last-child,
.detail_overview_container > :nth-child(2) > :last-child,
.detail_overview_container > :nth-child(3) > :last-child
 {
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1vmax;



}

.detail_overview_container > :first-child > :last-child > div,
.detail_overview_container > :nth-child(2) > :last-child > div,
.detail_overview_container > :nth-child(3) > :last-child > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1vmax;


}

.detail_overview_container > :first-child > :last-child > div > :first-child,
.detail_overview_container > :nth-child(2) > :last-child > div > :first-child ,
.detail_overview_container > :nth-child(3) > :last-child > div > :first-child {
    font-size: 2.8vmin;
  font-weight: 500;

}

.detail_overview_container > :first-child > :last-child > div > :nth-child(2),
.detail_overview_container > :nth-child(2) > :last-child > div > :nth-child(2),
.detail_overview_container > :nth-child(3) > :last-child > div > :nth-child(2) {
  text-align: center;
  font-size: 0.8vmax;
  font-weight: bold;

}

.detail_overview_container > :first-child > :last-child > div > :last-child,
.detail_overview_container > :nth-child(2) > :last-child > div > :last-child,
.detail_overview_container > :nth-child(3) > :last-child > div > :last-child
 {

  padding: 0.5vmax 1.5vmax;
  border-radius: 18px;
  cursor: pointer;
  font-size: 1.5vmin;
  /* background:linear-gradient(to right,rgb(2, 183, 249),rgb(171, 225, 242)); */

}

.progress_button_1 {
  background: linear-gradient(to right, rgb(1, 185, 127), rgb(150, 249, 227));
}

.progress_button_2 {
  background: linear-gradient(to right, rgb(245, 28, 28), rgb(238, 122, 122));
}

.progress_button_3 {
  background: linear-gradient(to right, rgb(112, 26, 233), rgb(151, 140, 239));
}

/* ###   Code For Detailed Container 1 --> Box-2    ### */

.detail_overview_2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1vmax;
  padding: 1vmin 0;


}

.detail_overview_2 > :first-child {
  /* width: 110%; */
  /* border: 2px solid red; */
  /* position: relative; */
}

.detail_overview_2 > :last-child {
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 0.8vmax;

}

.detail_overview_2 > :last-child > div {
  height: 5.5vmax;
  width: 5.5vmax;
  border-radius: 50%;
  border: 4px solid rgb(33, 232, 162);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;


}

.detail_overview_2 > :last-child > div > :first-child {
  font-size: 1vmax;
  font-weight: 600;
}

.detail_overview_2 > :last-child > div > :last-child {
  font-size: 0.8vmax;
}

.detail_overview_1 {
  /* color: rgb(30, 244, 194); */
}

/* ###   Code For Detailed Container 1 --> Box-3    ### */

.detail_overview_3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1vmax;
}

.detail_overview_3 > :first-child {
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 1vmax;
}

.detail_overview_3 > :first-child > span {
  /* font-size: 0.9vmax;
    padding: 0.5vmax 1.2vmax;
    border-radius: 20px;
    border: 3px solid rgb(21, 249, 199); */
}

.detail_overview_3 > :last-child {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 75%;

}

.detailed-responsive-container-1 {
  min-width: 600px;
  height: 30vh;
}
.detailed-responsive-container-2 {
  min-width: 600px;
  height: 30vh;
}
.detailed-responsive-container-3 {
  min-width: 600px;
  height: 30vh;
 
}

.detailed-responsive-container-4 {
  min-width: 600px;
  height: 30vh;
}



/* For PvsystActualGHI component */
.legend-container{
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
 text-align: center;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: white;
 flex-wrap: wrap;
 width: 100%;
 color: black;
 padding:0 5px;
 z-index: 1;
}
.legend-container>div{
  cursor: default;
}

@media screen and (max-width:1200px) {
    .detailed-responsive-container-1,.detailed-responsive-container-2,.detailed-responsive-container-3,.detailed-responsive-container-4{
        height: 40vh;
    }    
}

@media screen and (max-width: 1050px) {
  .detail_overview_container {
    flex-direction: column !important;
    height: auto !important;
    gap: 0.5vmax;
  }

  .detail_overview_container > :first-child {
    width: 100%;
    padding: 1vmax 2vmax;
    min-height: 35vh;
  }

  .detail_overview_container > :nth-child(2) {
    width: 100%;
    /* padding: 2vmax; */
    min-height: 35vh;
    gap: 2vmax;
  }

  .detail_overview_container > :last-child {
    min-height: 35vh;
    width: 100%;
    /* padding: 2vmax; */
  }

  .detail_overview_1 > :first-child {
    gap: 1.5vmax;
  }

  .detail_overview_1 > :first-child > div {
    gap: 1.2vmax;
  }

  .detail_overview_1 > :first-child > div > :last-child {
    font-size: 1.5vmax;
  }

  .detail_overview_1 > :first-child > div > :last-child > span > i {
    font-size: 2vmax;
    padding-left: 0.5vmax;
  }

  .detail_overview_container > :first-child > :last-child,
  .detail_overview_container > :nth-child(2) > :last-child,
  .detail_overview_container > :nth-child(3) > :last-child {
    gap: 2vmax;
  }

  .detail_overview_container > :first-child > :last-child > div > :first-child,
  .detail_overview_container
    > :nth-child(2)
    > :last-child
    > div
    > :first-child,.detail_overview_container
    > :nth-child(3)
    > :last-child
    > div
    > :first-child {
    font-size: 3vmax;
  }

  .detail_overview_container > :first-child > :last-child > div > :nth-child(2),
  .detail_overview_container
    > :nth-child(2)
    > :last-child
    > div
    > :nth-child(2),
    .detail_overview_container
    > :nth-child(3)
    > :last-child
    > div
    > :nth-child(2) {
    font-size: 1.5vmax;
  }

  .detail_overview_container > :first-child > :last-child > div > :last-child,
  .detail_overview_container > :nth-child(2) > :last-child > div > :last-child,
  .detail_overview_container > :nth-child(3) > :last-child > div > :last-child {
    font-size: 2vmax;
  }

  .detail_overview_2 > :last-child > div {
    height: 13vmin;
    width: 13vmin;
  }

  .detail_overview_2 > :last-child > div > :first-child {
    font-size: 2vmax;
  }

  .detail_overview_2 > :last-child > div > :last-child {
    font-size: 1.5vmax;
  }
}

@media screen and (max-width: 550px) {
  .detail_overview_container > :first-child {
    width: 100%;
    padding: 1vmax 2vmax;
    min-height: 30vh;
  }

  .detail_overview_container > :nth-child(2) {
    width: 100%;
    /* padding: 2vmax; */
    min-height: 30vh;
    gap: 2vmax;
  }

  .detail_overview_container > :last-child {
    min-height: 30vh;
    width: 100%;
    /* padding: 2vmax; */
  }

  .detail_overview_2 > :last-child > div {
    height: 17vmin;
    width: 17vmin;
  }
}
@media screen and (max-width: 400px){
  .detail_overview_2 > :last-child > div {
    height: 5rem;
    width: 5rem;

  }
  .detail_overview_1 > :first-child {
  gap: 2.5vmax;

  }
.detail_overview_1 > :first-child > div > :last-child > span > i {
  right: 0.5vmax;
  position: relative;

}
.detail_overview_container > :first-child > :last-child > div,
.detail_overview_container > :nth-child(2) > :last-child > div,.detail_overview_container > :nth-child(3) > :last-child > div{
  gap: 3vmax;

}
.detail_overview_container > :first-child > :last-child,
.detail_overview_container > :nth-child(2) > :last-child,
.detail_overview_container > :nth-child(3) > :last-child
{
  gap: 0.5vmax;
}

.detail_overview_container > :first-child > :last-child > div > :first-child,
.detail_overview_container > :nth-child(2) > :last-child > div > :first-child,
.detail_overview_container > :nth-child(3) > :last-child > div > :first-child
{
  font-size: 2.2vmax;

}
.detail_overview_2 > :last-child > div{
  padding: 1vmin;
}

}`, "",{"version":3,"sources":["webpack://./src/modules/diagonisticModel/Detailed.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;EACxD,6EAA6E;EAC7E;;;;;GAKC;;AAEH;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,yDAAyD;;AAEzD;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;;;AAGd;;AAEA;EAEE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;;;;EAKE,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,8DAA8D;AAChE;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE;;;;cAIY;AACd;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;;AAGrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;EAIE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;;;;AAIZ;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;;;AAGZ;;AAEA;;;IAGI,kBAAkB;EACpB,gBAAgB;;AAElB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;;;;;EAKE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8EAA8E;;AAEhF;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;;;AAGlB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;;;AAGxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE;;;0CAGwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;;AAEb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;;;AAIA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;CACT,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;CACvB,eAAe;CACf,WAAW;CACX,YAAY;CACZ,aAAa;CACb,UAAU;AACX;AACA;EACE,eAAe;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;EACE;IACE,iCAAiC;IACjC,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;;;IAGE,UAAU;EACZ;;EAEA;;;;;;;;;;IAUE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;IAWE,kBAAkB;EACpB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;;EAEb;EACA;EACA,YAAY;;EAEZ;AACF;EACE,cAAc;EACd,kBAAkB;;AAEpB;AACA;;EAEE,UAAU;;AAEZ;AACA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,kBAAkB;;AAEpB;AACA;EACE,cAAc;AAChB;;AAEA","sourcesContent":["/* ##### -> Components -> Code for Detailed, GenOverView*/\n\n.css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {\n  font-weight: bolder;\n}\n\n.left_box_1 {\n  font-size: 1.3vmax;\n}\n\n.detail_overview_container {\n  background: linear-gradient(to right, whitesmoke, white);\n  background: linear-gradient(to right, rgb(120, 118, 118), rgb(119, 100, 100));\n  background: linear-gradient(\n    to bottom,\n    rgb(3, 99, 125),\n    rgb(4, 128, 162),\n    rgb(4, 135, 172)\n  );\n  \n}\n\n.detail_overview_container > :first-child {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  background-color: white;\n  justify-content: space-between;\n  gap: 2vmax;\n  padding:1vmax 0.5vmax;\n  position: relative;\n}\n\n.detail_overview_container > :nth-child(2) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  background-color: white;\n  gap: 2vmax;\n  padding:1vmax 0.5vmax;\n  position: relative;\n}\n\n.detail_overview_container > :nth-child(3) {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  background-color: white;\n  justify-content: space-between;\n  gap: 2vmax;\n  padding:1vmax 0.5vmax;\n  position: relative;\n}\n\n/* ###   Code For Detailed Container 1 --> Box-1    ### */\n\n.detail_overview_1 > :first-child {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1vmax;\n\n}\n\n.detail_overview_1 > :first-child > div {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5vmin;\n\n\n}\n\n.detail_overview_1 > :first-child > div > :first-child > progress {\n  -webkit-appearance: none;\n  appearance: none;\n  height: 1rem;\n  width: 100%;\n  transition: border 0.2s linear;\n  transition: 0.2s all;\n}\n\n.progress_1[value]::-webkit-progress-bar,\n.progress_2[value]::-webkit-progress-bar,\n.progress_3[value]::-webkit-progress-bar,\n.progress_4[value]::-webkit-progress-bar,\n.progress_5[value]::-webkit-progress-bar {\n  background-color: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;\n  border-radius: 18px;\n}\n\n.progress_1[value]::-webkit-progress-value,\n.progress_2[value]::-webkit-progress-value,\n.progress_3[value]::-webkit-progress-value,\n.progress_4[value]::-webkit-progress-value,\n.progress_5[value]::-webkit-progress-value {\n  border-radius: 18px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  background: linear-gradient(to right, red, rgb(238, 201, 201));\n}\n\n.progress_1[value]::-webkit-progress-value {\n  background: linear-gradient(\n    to right,\n    rgb(1, 185, 127),\n    rgb(150, 249, 227)\n  ) !important;\n}\n\n.progress_2[value]::-webkit-progress-value {\n  background: linear-gradient(\n    to right,\n    rgb(231, 3, 3),\n    rgb(250, 96, 96)\n  ) !important;\n}\n\n.progress_3[value]::-webkit-progress-value {\n  background: linear-gradient(\n    to right,\n    rgb(84, 4, 197),\n    rgb(151, 140, 239)\n  ) !important;\n}\n\n.progress_4[value]::-webkit-progress-value {\n  background: linear-gradient(\n    to right,\n    rgb(1, 185, 127),\n    rgb(150, 249, 227)\n  ) !important;\n}\n\n.progress_5[value]::-webkit-progress-value {\n  background: linear-gradient(\n    to right,\n    rgb(231, 3, 3),\n    rgb(250, 96, 96)\n  ) !important;\n}\n\n.detail_overview_1 > :last-child {\n}\n\n.detail_overview_1 > :first-child > div > :last-child {\n  position: relative;\n  width: 100%;\n  font-size: 0.8vmax;\n  padding: 0 0.2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n\n}\n\n.detail_overview_1 > :first-child > div > :last-child > span > i {\n  font-size: 1.4vmax;\n  color: rgb(98, 92, 92);\n}\n\n.detail_overview_container > :first-child > :last-child,\n.detail_overview_container > :nth-child(2) > :last-child,\n.detail_overview_container > :nth-child(3) > :last-child\n {\n  width: 55%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1vmax;\n\n\n\n}\n\n.detail_overview_container > :first-child > :last-child > div,\n.detail_overview_container > :nth-child(2) > :last-child > div,\n.detail_overview_container > :nth-child(3) > :last-child > div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1vmax;\n\n\n}\n\n.detail_overview_container > :first-child > :last-child > div > :first-child,\n.detail_overview_container > :nth-child(2) > :last-child > div > :first-child ,\n.detail_overview_container > :nth-child(3) > :last-child > div > :first-child {\n    font-size: 2.8vmin;\n  font-weight: 500;\n\n}\n\n.detail_overview_container > :first-child > :last-child > div > :nth-child(2),\n.detail_overview_container > :nth-child(2) > :last-child > div > :nth-child(2),\n.detail_overview_container > :nth-child(3) > :last-child > div > :nth-child(2) {\n  text-align: center;\n  font-size: 0.8vmax;\n  font-weight: bold;\n\n}\n\n.detail_overview_container > :first-child > :last-child > div > :last-child,\n.detail_overview_container > :nth-child(2) > :last-child > div > :last-child,\n.detail_overview_container > :nth-child(3) > :last-child > div > :last-child\n {\n\n  padding: 0.5vmax 1.5vmax;\n  border-radius: 18px;\n  cursor: pointer;\n  font-size: 1.5vmin;\n  /* background:linear-gradient(to right,rgb(2, 183, 249),rgb(171, 225, 242)); */\n\n}\n\n.progress_button_1 {\n  background: linear-gradient(to right, rgb(1, 185, 127), rgb(150, 249, 227));\n}\n\n.progress_button_2 {\n  background: linear-gradient(to right, rgb(245, 28, 28), rgb(238, 122, 122));\n}\n\n.progress_button_3 {\n  background: linear-gradient(to right, rgb(112, 26, 233), rgb(151, 140, 239));\n}\n\n/* ###   Code For Detailed Container 1 --> Box-2    ### */\n\n.detail_overview_2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1vmax;\n  padding: 1vmin 0;\n\n\n}\n\n.detail_overview_2 > :first-child {\n  /* width: 110%; */\n  /* border: 2px solid red; */\n  /* position: relative; */\n}\n\n.detail_overview_2 > :last-child {\n  width: 100%;\n  height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0 0.8vmax;\n\n}\n\n.detail_overview_2 > :last-child > div {\n  height: 5.5vmax;\n  width: 5.5vmax;\n  border-radius: 50%;\n  border: 4px solid rgb(33, 232, 162);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n\n}\n\n.detail_overview_2 > :last-child > div > :first-child {\n  font-size: 1vmax;\n  font-weight: 600;\n}\n\n.detail_overview_2 > :last-child > div > :last-child {\n  font-size: 0.8vmax;\n}\n\n.detail_overview_1 {\n  /* color: rgb(30, 244, 194); */\n}\n\n/* ###   Code For Detailed Container 1 --> Box-3    ### */\n\n.detail_overview_3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1vmax;\n}\n\n.detail_overview_3 > :first-child {\n  height: 25%;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  gap: 1vmax;\n}\n\n.detail_overview_3 > :first-child > span {\n  /* font-size: 0.9vmax;\n    padding: 0.5vmax 1.2vmax;\n    border-radius: 20px;\n    border: 3px solid rgb(21, 249, 199); */\n}\n\n.detail_overview_3 > :last-child {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  height: 75%;\n\n}\n\n.detailed-responsive-container-1 {\n  min-width: 600px;\n  height: 30vh;\n}\n.detailed-responsive-container-2 {\n  min-width: 600px;\n  height: 30vh;\n}\n.detailed-responsive-container-3 {\n  min-width: 600px;\n  height: 30vh;\n \n}\n\n.detailed-responsive-container-4 {\n  min-width: 600px;\n  height: 30vh;\n}\n\n\n\n/* For PvsystActualGHI component */\n.legend-container{\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n text-align: center;\n display: flex;\n align-items: center;\n justify-content: center;\n background-color: white;\n flex-wrap: wrap;\n width: 100%;\n color: black;\n padding:0 5px;\n z-index: 1;\n}\n.legend-container>div{\n  cursor: default;\n}\n\n@media screen and (max-width:1200px) {\n    .detailed-responsive-container-1,.detailed-responsive-container-2,.detailed-responsive-container-3,.detailed-responsive-container-4{\n        height: 40vh;\n    }    \n}\n\n@media screen and (max-width: 1050px) {\n  .detail_overview_container {\n    flex-direction: column !important;\n    height: auto !important;\n    gap: 0.5vmax;\n  }\n\n  .detail_overview_container > :first-child {\n    width: 100%;\n    padding: 1vmax 2vmax;\n    min-height: 35vh;\n  }\n\n  .detail_overview_container > :nth-child(2) {\n    width: 100%;\n    /* padding: 2vmax; */\n    min-height: 35vh;\n    gap: 2vmax;\n  }\n\n  .detail_overview_container > :last-child {\n    min-height: 35vh;\n    width: 100%;\n    /* padding: 2vmax; */\n  }\n\n  .detail_overview_1 > :first-child {\n    gap: 1.5vmax;\n  }\n\n  .detail_overview_1 > :first-child > div {\n    gap: 1.2vmax;\n  }\n\n  .detail_overview_1 > :first-child > div > :last-child {\n    font-size: 1.5vmax;\n  }\n\n  .detail_overview_1 > :first-child > div > :last-child > span > i {\n    font-size: 2vmax;\n    padding-left: 0.5vmax;\n  }\n\n  .detail_overview_container > :first-child > :last-child,\n  .detail_overview_container > :nth-child(2) > :last-child,\n  .detail_overview_container > :nth-child(3) > :last-child {\n    gap: 2vmax;\n  }\n\n  .detail_overview_container > :first-child > :last-child > div > :first-child,\n  .detail_overview_container\n    > :nth-child(2)\n    > :last-child\n    > div\n    > :first-child,.detail_overview_container\n    > :nth-child(3)\n    > :last-child\n    > div\n    > :first-child {\n    font-size: 3vmax;\n  }\n\n  .detail_overview_container > :first-child > :last-child > div > :nth-child(2),\n  .detail_overview_container\n    > :nth-child(2)\n    > :last-child\n    > div\n    > :nth-child(2),\n    .detail_overview_container\n    > :nth-child(3)\n    > :last-child\n    > div\n    > :nth-child(2) {\n    font-size: 1.5vmax;\n  }\n\n  .detail_overview_container > :first-child > :last-child > div > :last-child,\n  .detail_overview_container > :nth-child(2) > :last-child > div > :last-child,\n  .detail_overview_container > :nth-child(3) > :last-child > div > :last-child {\n    font-size: 2vmax;\n  }\n\n  .detail_overview_2 > :last-child > div {\n    height: 13vmin;\n    width: 13vmin;\n  }\n\n  .detail_overview_2 > :last-child > div > :first-child {\n    font-size: 2vmax;\n  }\n\n  .detail_overview_2 > :last-child > div > :last-child {\n    font-size: 1.5vmax;\n  }\n}\n\n@media screen and (max-width: 550px) {\n  .detail_overview_container > :first-child {\n    width: 100%;\n    padding: 1vmax 2vmax;\n    min-height: 30vh;\n  }\n\n  .detail_overview_container > :nth-child(2) {\n    width: 100%;\n    /* padding: 2vmax; */\n    min-height: 30vh;\n    gap: 2vmax;\n  }\n\n  .detail_overview_container > :last-child {\n    min-height: 30vh;\n    width: 100%;\n    /* padding: 2vmax; */\n  }\n\n  .detail_overview_2 > :last-child > div {\n    height: 17vmin;\n    width: 17vmin;\n  }\n}\n@media screen and (max-width: 400px){\n  .detail_overview_2 > :last-child > div {\n    height: 5rem;\n    width: 5rem;\n\n  }\n  .detail_overview_1 > :first-child {\n  gap: 2.5vmax;\n\n  }\n.detail_overview_1 > :first-child > div > :last-child > span > i {\n  right: 0.5vmax;\n  position: relative;\n\n}\n.detail_overview_container > :first-child > :last-child > div,\n.detail_overview_container > :nth-child(2) > :last-child > div,.detail_overview_container > :nth-child(3) > :last-child > div{\n  gap: 3vmax;\n\n}\n.detail_overview_container > :first-child > :last-child,\n.detail_overview_container > :nth-child(2) > :last-child,\n.detail_overview_container > :nth-child(3) > :last-child\n{\n  gap: 0.5vmax;\n}\n\n.detail_overview_container > :first-child > :last-child > div > :first-child,\n.detail_overview_container > :nth-child(2) > :last-child > div > :first-child,\n.detail_overview_container > :nth-child(3) > :last-child > div > :first-child\n{\n  font-size: 2.2vmax;\n\n}\n.detail_overview_2 > :last-child > div{\n  padding: 1vmin;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
